import {NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { WatchUsLive } from './watchuslive.component';
import { TRANSLATION_PROVIDERS, TranslatePipe, TranslateService } from './translate/index';
import { UtilityModule } from '../utility/utility.module';




export class WatchUsLiveModule { }




// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../watchuslive/watchuslive.module.ts